"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
const types_1 = require("../stage/types");
var Country;
(function (Country) {
    Country["Brazil"] = "BR";
    Country["Canada"] = "CA";
    Country["France"] = "FR";
    Country["Germany"] = "DE";
    Country["Italy"] = "IT";
    Country["Japan"] = "JP";
    Country["Spain"] = "ES";
    Country["UK"] = "GB";
    Country["US"] = "US";
})(Country = exports.Country || (exports.Country = {}));
